import { createReducer, on } from '@ngrx/store';
import * as MenuByUserActions from './menu-by-user.actions';
import { initialMenuByUserState } from './menu-by-user.model';

export const menuByUserReducer = createReducer(
  initialMenuByUserState,
  on(MenuByUserActions.loadMenuByUser, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(MenuByUserActions.loadMenuByUserSuccess, (state, { response }) => ({
    ...state,
    data: response,
    loading: false,
    error: null,
  })),
  on(MenuByUserActions.loadMenuByUserFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
  on(MenuByUserActions.resetMenuByUser, () => initialMenuByUserState),
);
